import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import { Modal, Button, Form } from 'react-bootstrap';
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import { API_URL } from '../../config/api';
import BlingAccountManager from '../../components/bling/BlingAccountManager';
import './BlingIntegrationPage.css';

const BlingIntegrationPage = () => {
  const [activeTab, setActiveTab] = useState('contas');
  const [contas, setContas] = useState([]);
  const [regras, setRegras] = useState([]);
  const [showContaModal, setShowContaModal] = useState(false);
  const [showRegraModal, setShowRegraModal] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [contaParaAutorizar, setContaParaAutorizar] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showResultModal, setShowResultModal] = useState(false);
  const [resultMessage, setResultMessage] = useState('');
  const [resultType, setResultType] = useState('success');

  // Estados para modal de conta
  const [contaForm, setContaForm] = useState({
    nome: '',
    client_id: '',
    client_secret: ''
  });

  // Estados para modal de regra
  const [regraForm, setRegraForm] = useState({
    produto_id: '',
    plano_id: '',
    sku_bling: '',
    conta_id: '',
    momento_envio: ''
  });

  // Estados para dados reais
  const [produtos, setProdutos] = useState([]);
  const [planosProduto, setPlanosProduto] = useState([]);

  useEffect(() => {
    loadContas();
    loadRegras();
    loadProdutos();
    
    // Verificar se há parâmetros de retorno da autorização
    const urlParams = new URLSearchParams(window.location.search);
    const auth = urlParams.get('auth');
    const message = urlParams.get('message');
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    
    console.log('🔍 Verificando parâmetros de retorno:', { auth, message, code, state, search: window.location.search });
    
    if (auth && message) {
      console.log('✅ Parâmetros encontrados! Mostrando modal...');
      setResultType(auth);
      setResultMessage(decodeURIComponent(message));
      setShowResultModal(true);
      
      // Limpar URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  const loadContas = async () => {
    try {
      setLoading(true);
      
      const token = localStorage.getItem('auth_token') || localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/bling/contas`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('✅ Contas carregadas:', data);
        setContas(data.data || []);
      } else {
        console.error('❌ Erro ao carregar contas:', response.status);
        setContas([]);
      }
    } catch (error) {
      console.error('❌ Erro ao carregar contas:', error);
      setContas([]);
    } finally {
      setLoading(false);
    }
  };

  const validarCredenciais = (client_id, client_secret) => {
    const erros = [];

    // Validar formato do client_id
    if (!client_id || client_id.length < 10) {
      erros.push('• Client ID deve ter pelo menos 10 caracteres');
    }

    // Validar formato do client_secret
    if (!client_secret || client_secret.length < 20) {
      erros.push('• Client Secret deve ter pelo menos 20 caracteres');
    }

    // Validar se contém apenas caracteres válidos
    if (client_id && !/^[a-zA-Z0-9]+$/.test(client_id)) {
      erros.push('• Client ID deve conter apenas letras e números');
    }

    if (client_secret && !/^[a-zA-Z0-9]+$/.test(client_secret)) {
      erros.push('• Client Secret deve conter apenas letras e números');
    }

    return erros;
  };

  const loadProdutos = async () => {
    try {
      setLoading(true);
      
      const token = localStorage.getItem('auth_token') || localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/bling/produtos`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('✅ Produtos carregados:', data);
        setProdutos(data.data || []);
      } else {
        console.error('❌ Erro ao carregar produtos:', response.status);
      }
    } catch (error) {
      console.error('❌ Erro ao carregar produtos:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadPlanosProduto = async (produtoId) => {
    if (!produtoId) {
      setPlanosProduto([]);
      return;
    }

    try {
      setLoading(true);
      
      const token = localStorage.getItem('auth_token') || localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/bling/produtos/${produtoId}/planos`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('✅ Planos do produto carregados:', data);
        setPlanosProduto(data.data?.planos || []);
      } else {
        console.error('❌ Erro ao carregar planos do produto:', response.status);
        setPlanosProduto([]);
      }
    } catch (error) {
      console.error('❌ Erro ao carregar planos do produto:', error);
      setPlanosProduto([]);
    } finally {
      setLoading(false);
    }
  };

  const loadRegras = async () => {
    try {
      setLoading(true);
      
      const token = localStorage.getItem('auth_token') || localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/bling/regras`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('✅ Regras carregadas:', data);
        setRegras(data.data || []);
      } else {
        console.error('❌ Erro ao carregar regras:', response.status);
        setRegras([]);
      }
    } catch (error) {
      console.error('❌ Erro ao carregar regras:', error);
      setRegras([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveConta = async () => {
    try {
      setLoading(true);
      
      // Validação básica
      if (!contaForm.nome || !contaForm.client_id || !contaForm.client_secret) {
        alert('Por favor, preencha todos os campos obrigatórios.');
        return;
      }

      // Validação de formato das credenciais
      const errosValidacao = validarCredenciais(contaForm.client_id, contaForm.client_secret);
      if (errosValidacao.length > 0) {
        alert('Erro na validação das credenciais:\n\n' + errosValidacao.join('\n'));
        return;
      }

      // Testar conectividade com Bling antes de salvar
      console.log('🔍 Testando conectividade com Bling...');
      const token = localStorage.getItem('auth_token') || localStorage.getItem('token');
      
      const testResponse = await fetch(`${API_URL}/api/bling/test-credentials`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          client_id: contaForm.client_id,
          client_secret: contaForm.client_secret
        })
      });

      const testResult = await testResponse.json();
      
      if (!testResult.success) {
        alert('❌ Erro na validação das credenciais:\n\n' + testResult.message);
        return;
      }

      console.log('✅ Credenciais válidas! Salvando conta...');

      // Salvar conta após validação bem-sucedida
      const response = await fetch(`${API_URL}/api/bling/contas`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          nome: contaForm.nome,
          client_id: contaForm.client_id,
          client_secret: contaForm.client_secret
        })
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('✅ Conta salva com sucesso:', data);
        
        // Fechar modal e limpar formulário
        setShowContaModal(false);
        setContaForm({ nome: '', client_id: '', client_secret: '' });
        
        // Recarregar lista de contas
        loadContas();
        
        alert('✅ Conta criada com sucesso!\n\nCredenciais validadas e conectividade confirmada.');
      } else {
        const errorData = await response.json();
        console.error('❌ Erro ao salvar conta:', errorData);
        alert(errorData.message || 'Erro ao salvar conta. Tente novamente.');
      }
    } catch (error) {
      console.error('❌ Erro ao salvar conta:', error);
      alert('Erro ao salvar conta. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleSaveRegra = async () => {
    try {
      setLoading(true);
      
      // Validação básica
      if (!regraForm.produto_id || !regraForm.plano_id || !regraForm.sku_bling || !regraForm.conta_id || !regraForm.momento_envio) {
        alert('Por favor, preencha todos os campos obrigatórios.');
        return;
      }

      const token = localStorage.getItem('auth_token') || localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/bling/regras`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          produto_id: parseInt(regraForm.produto_id),
          plano_id: parseInt(regraForm.plano_id),
          sku_bling: regraForm.sku_bling,
          conta_id: parseInt(regraForm.conta_id),
          momento_envio: regraForm.momento_envio
        })
      });

      if (response.ok) {
        const result = await response.json();
        console.log('✅ Regra criada:', result);
        setShowRegraModal(false);
        setRegraForm({ produto_id: '', plano_id: '', sku_bling: '', conta_id: '', momento_envio: '' });
        setPlanosProduto([]);
        loadRegras();
        alert('Regra criada com sucesso!');
      } else {
        const errorData = await response.json();
        console.error('❌ Erro ao salvar regra:', errorData);
        alert(errorData.message || 'Erro ao salvar regra. Tente novamente.');
      }
    } catch (error) {
      console.error('❌ Erro ao salvar regra:', error);
      alert('Erro ao salvar regra: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAutorizarConta = (conta) => {
    setContaParaAutorizar(conta);
    setShowAuthModal(true);
  };


  const confirmarAutorizacao = async () => {
    if (!contaParaAutorizar) return;

    try {
      setLoading(true);
      console.log('🔗 Iniciando autorização OAuth com Bling:', contaParaAutorizar.nome);
      
      // Construir URL de autorização da Bling com o client_id real
      // URL sem hash (Bling não permite #)
      const redirectUri = 'http://localhost:3002/bling-callback.html';
      const blingAuthUrl = `https://www.bling.com.br/Api/v3/oauth/authorize?response_type=code&client_id=${contaParaAutorizar.client_id}&state=${contaParaAutorizar.id}&redirect_uri=${encodeURIComponent(redirectUri)}`;
      
      console.log('🔗 Redirecionando para Bling:', blingAuthUrl);
      
      // Fechar modal antes de redirecionar
      setShowAuthModal(false);
      setContaParaAutorizar(null);
      setLoading(false);
      
      // Redirecionar para a Bling
      window.location.href = blingAuthUrl;
      
    } catch (error) {
      console.error('❌ Erro ao iniciar autorização:', error);
      alert('❌ Erro ao iniciar autorização: ' + error.message);
      setLoading(false);
      setShowAuthModal(false);
      setContaParaAutorizar(null);
    }
  };

  const tabs = [
    { id: 'contas', name: 'Contas', icon: 'mdi:cog' },
    { id: 'regras', name: 'Regras', icon: 'mdi:check-circle' }
  ];

  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Integração Bling" />
        
        <div className="card bg-transparent border-0">
          {/* Header */}
          <div className="card-header d-flex align-items-center justify-content-between gap-3 mb-4">
            <div>
              <span style={{ 
                fontSize: '20px', 
                fontWeight: '600',
                display: 'block',
                color: 'var(--dark-text-primary, #1a1a1a)'
              }}>
                Integração Bling ERP
              </span>
              <span style={{ 
                fontSize: '14px', 
                display: 'block',
                color: 'var(--dark-text-secondary, #6b7280)',
                marginTop: '4px'
              }}>
                Configure suas contas Bling e defina as regras de sincronização
              </span>
            </div>
          </div>

          {/* Tabs */}
          <div className="border-bottom px-24 pt-0">
            <div className="d-flex align-items-center gap-4 overflow-auto pb-2">
              {tabs.map((tab) => (
                <div
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`d-flex align-items-center gap-2 pb-8 pe-24 cursor-pointer ${
                    activeTab === tab.id
                      ? 'border-bottom border-primary-600 text-primary-600 fw-semibold'
                      : 'text-secondary-light'
                  }`}
                  style={{ cursor: 'pointer' }}
                >
                  <Icon icon={tab.icon} className="text-lg" />
                  <span>{tab.name}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Tab Content */}
          <div className="card-body">
            {activeTab === 'contas' && (
              <div>
                {/* Header da aba Contas */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <span style={{ 
                      fontSize: '18px', 
                      fontWeight: '600',
                      display: 'block',
                      color: 'var(--dark-text-primary, #1a1a1a)'
                    }}>
                      Contas Bling
                    </span>
                    <span style={{ 
                      fontSize: '14px', 
                      display: 'block',
                      color: 'var(--dark-text-secondary, #6b7280)',
                      marginTop: '4px'
                    }}>
                      Configure e autorize suas contas do Bling ERP
                    </span>
                  </div>
                  <button
                    onClick={() => setShowContaModal(true)}
                    className="btn btn-primary d-flex align-items-center gap-2"
                  >
                    <Icon icon="mdi:plus" className="text-lg" />
                    Nova Conta
                  </button>
                </div>

                {/* Lista de Contas */}
                <div className="card">
                  <div className="card-header">
                    <span style={{ 
                      fontSize: '16px', 
                      fontWeight: '500',
                      color: 'var(--dark-text-primary, #1a1a1a)'
                    }}>
                      Contas Configuradas
                    </span>
                  </div>
                  <div className="card-body p-0">
                    {contas.length === 0 ? (
                      <div className="text-center py-5">
                        <Icon icon="mdi:account-off" className="text-5xl text-secondary-light mb-3" />
                        <span style={{ 
                          fontSize: '14px', 
                          color: 'var(--dark-text-secondary, #6b7280)'
                        }}>
                          Nenhuma conta configurada ainda
                        </span>
                      </div>
                    ) : (
                      <div className="list-group list-group-flush">
                        {contas.map((conta) => (
                          <div key={conta.id} className="list-group-item d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center gap-3">
                              <div>
                                {conta.status === 'ativa' ? (
                                  <Icon icon="mdi:check-circle" className="text-2xl text-success" />
                                ) : (
                                  <Icon icon="mdi:close-circle" className="text-2xl text-danger" />
                                )}
                              </div>
                              <div>
                                <div className="d-flex align-items-center gap-2">
                                  <span style={{ 
                                    fontSize: '16px', 
                                    fontWeight: '500',
                                    color: 'var(--dark-text-primary, #1a1a1a)'
                                  }}>
                                    {conta.nome}
                                  </span>
                                  {conta.status === 'ativa' && (
                                    <span className="badge bg-success">
                                      <Icon icon="mdi:check" className="me-1" />
                                      Ativa
                                    </span>
                                  )}
                                  {conta.status === 'pendente' && (
                                    <span className="badge bg-warning">
                                      <Icon icon="mdi:clock" className="me-1" />
                                      Pendente
                                    </span>
                                  )}
                                </div>
                                <span style={{ 
                                  fontSize: '12px', 
                                  display: 'block',
                                  color: 'var(--dark-text-secondary, #6b7280)'
                                }}>
                                  ID: {conta.client_id}
                                </span>
                                <span style={{ 
                                  fontSize: '12px', 
                                  display: 'block',
                                  color: 'var(--dark-text-secondary, #6b7280)'
                                }}>
                                  Última sincronização: {conta.ultima_sincronizacao}
                                </span>
                              </div>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                              {conta.status === 'pendente' ? (
                                <button 
                                  className="btn btn-sm btn-success"
                                  onClick={() => handleAutorizarConta(conta)}
                                  title="Autorizar conta no Bling"
                                  disabled={loading}
                                >
                                  <Icon icon="mdi:check-circle" className="me-1" />
                                  {loading ? 'Autorizando...' : 'Autorizar'}
                                </button>
                              ) : conta.status === 'ativa' ? (
                                <button 
                                  className="btn btn-sm btn-success"
                                  disabled
                                  title="Conta já autorizada"
                                >
                                  <Icon icon="mdi:check-circle" className="me-1" />
                                  Autorizada
                                </button>
                              ) : null}
                              <button className="btn btn-sm btn-outline-secondary">
                                <Icon icon="mdi:pencil" />
                              </button>
                              <button className="btn btn-sm btn-outline-danger">
                                <Icon icon="mdi:trash" />
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'regras' && (
              <div>
                {/* Header da aba Regras */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <span style={{ 
                      fontSize: '18px', 
                      fontWeight: '600',
                      display: 'block',
                      color: 'var(--dark-text-primary, #1a1a1a)'
                    }}>
                      Regras de Sincronização
                    </span>
                    <span style={{ 
                      fontSize: '14px', 
                      display: 'block',
                      color: 'var(--dark-text-secondary, #6b7280)',
                      marginTop: '4px'
                    }}>
                      Defina quais produtos e planos serão enviados para o Bling
                    </span>
                  </div>
                  <button
                    onClick={() => setShowRegraModal(true)}
                    className="btn btn-primary d-flex align-items-center gap-2"
                  >
                    <Icon icon="mdi:plus" className="text-lg" />
                    Nova Regra
                  </button>
                </div>

                {/* Lista de Regras */}
                <div className="card">
                  <div className="card-header">
                    <span style={{ 
                      fontSize: '16px', 
                      fontWeight: '500',
                      color: 'var(--dark-text-primary, #1a1a1a)'
                    }}>
                      Regras Configuradas
                    </span>
                  </div>
                  <div className="card-body p-0">
                    {regras.length === 0 ? (
                      <div className="text-center py-5">
                        <Icon icon="mdi:cog-off" className="text-5xl text-secondary-light mb-3" />
                        <span style={{ 
                          fontSize: '14px', 
                          color: 'var(--dark-text-secondary, #6b7280)'
                        }}>
                          Nenhuma regra configurada ainda
                        </span>
                      </div>
                    ) : (
                      <div className="list-group list-group-flush">
                        {regras.map((regra) => (
                          <div key={regra.id} className="list-group-item">
                            <div className="d-flex justify-content-between align-items-start">
                              <div className="d-flex align-items-start gap-3">
                                <div className="mt-1">
                                  {regra.status === 'ativa' ? (
                                    <Icon icon="mdi:check-circle" className="text-2xl text-success" />
                                  ) : (
                                    <Icon icon="mdi:alert-circle" className="text-2xl text-warning" />
                                  )}
                                </div>
                                <div>
                                  <span style={{ 
                                    fontSize: '16px', 
                                    fontWeight: '500',
                                    display: 'block',
                                    color: 'var(--dark-text-primary, #1a1a1a)'
                                  }}>
                                    {regra.produto}
                                  </span>
                                  <span style={{ 
                                    fontSize: '12px', 
                                    display: 'block',
                                    color: 'var(--dark-text-secondary, #6b7280)',
                                    marginTop: '2px'
                                  }}>
                                    Plano: {regra.plano_nome || 'N/A'}
                                  </span>
                                  <span style={{ 
                                    fontSize: '12px', 
                                    display: 'block',
                                    color: 'var(--dark-text-secondary, #6b7280)'
                                  }}>
                                    SKU Bling: {regra.sku_bling} | Conta: {regra.conta}
                                  </span>
                                  <span style={{ 
                                    fontSize: '12px', 
                                    display: 'block',
                                    color: 'var(--dark-text-secondary, #6b7280)'
                                  }}>
                                    Envio: {regra.momento_envio}
                                  </span>
                                </div>
                              </div>
                              <div className="d-flex align-items-center gap-2">
                                <button className="btn btn-sm btn-outline-secondary">
                                  <Icon icon="mdi:pencil" />
                                </button>
                                <button className="btn btn-sm btn-outline-danger">
                                  <Icon icon="mdi:trash" />
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Modal Nova Conta */}
        <Modal show={showContaModal} onHide={() => setShowContaModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>+ Nova Conta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Nome da conta <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  value={contaForm.nome}
                  onChange={(e) => setContaForm({...contaForm, nome: e.target.value})}
                  placeholder="Insira aqui o nome ou apelido da conta"
                />
              </Form.Group>
              
              <Form.Group className="mb-3">
                <Form.Label>Identificador (client_id) <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  value={contaForm.client_id}
                  onChange={(e) => setContaForm({...contaForm, client_id: e.target.value})}
                  placeholder="Insira aqui o identificador (client_id)"
                />
              </Form.Group>
              
              <Form.Group className="mb-3">
                <Form.Label>Chave Secreta (client_secret) <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="password"
                  value={contaForm.client_secret}
                  onChange={(e) => setContaForm({...contaForm, client_secret: e.target.value})}
                  placeholder="Insira aqui a chave (client_secret)"
                />
              </Form.Group>
              
              <div className="alert alert-info d-flex align-items-start">
                <Icon icon="mdi:information" className="me-2 mt-1" />
                <span style={{ fontSize: '14px' }}>
                  Após salvar e autorizar sua conta acesse o botão de editar e configure as formas de pagamento utilizadas no Bling.
                </span>
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowContaModal(false)}>
              Fechar
            </Button>
            <Button variant="primary" onClick={handleSaveConta} disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar'}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal Nova Regra */}
        <Modal show={showRegraModal} onHide={() => setShowRegraModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>+ Nova Regra</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Produto <span className="text-danger">*</span></Form.Label>
                <Form.Select
                  value={regraForm.produto_id}
                  onChange={(e) => {
                    const produtoId = e.target.value;
                    setRegraForm({...regraForm, produto_id: produtoId, plano_id: ''});
                    loadPlanosProduto(produtoId);
                  }}
                >
                  <option value="">Selecione um produto</option>
                  {produtos.map(produto => (
                    <option key={produto.id} value={produto.id}>
                      {produto.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              
              <Form.Group className="mb-3">
                <Form.Label>Plano <span className="text-danger">*</span></Form.Label>
                <Form.Select
                  value={regraForm.plano_id}
                  onChange={(e) => {
                    const planoId = e.target.value;
                    const planoSelecionado = planosProduto.find(p => p.id == planoId);
                    setRegraForm({
                      ...regraForm, 
                      plano_id: planoId,
                      sku_bling: planoSelecionado ? planoSelecionado.sku_code : ''
                    });
                  }}
                  disabled={!regraForm.produto_id || planosProduto.length === 0}
                >
                  <option value="">Selecione um plano</option>
                  {planosProduto.map(plano => (
                    <option key={plano.id} value={plano.id}>
                      {plano.name} - R$ {(plano.price / 100).toFixed(2).replace('.', ',')} ({plano.sku_code})
                    </option>
                  ))}
                </Form.Select>
                {regraForm.produto_id && planosProduto.length === 0 && (
                  <div className="text-warning mt-1" style={{ fontSize: '12px' }}>
                    Nenhum plano encontrado para este produto
                  </div>
                )}
                {!regraForm.produto_id && (
                  <div className="text-muted mt-1" style={{ fontSize: '12px' }}>
                    Selecione um produto primeiro
                  </div>
                )}
              </Form.Group>
              
              <Form.Group className="mb-3">
                <Form.Label>Código (SKU) do produto na Bling <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  value={regraForm.sku_bling}
                  onChange={(e) => setRegraForm({...regraForm, sku_bling: e.target.value})}
                  placeholder="Preenchido automaticamente ao selecionar o plano"
                  style={{ 
                    backgroundColor: regraForm.sku_bling ? '#f8f9fa' : 'white',
                    borderColor: regraForm.sku_bling ? '#28a745' : '#ced4da'
                  }}
                />
                {regraForm.sku_bling && (
                  <div className="text-success mt-1" style={{ fontSize: '12px' }}>
                    ✅ SKU preenchido automaticamente do plano selecionado
                  </div>
                )}
              </Form.Group>
              
              <Form.Group className="mb-3">
                <Form.Label>Conta <span className="text-danger">*</span></Form.Label>
                <Form.Select
                  value={regraForm.conta_id}
                  onChange={(e) => setRegraForm({...regraForm, conta_id: e.target.value})}
                >
                  <option value="">Selecione uma conta</option>
                  {contas.filter(conta => conta.status === 'ativa').map(conta => (
                    <option key={conta.id} value={conta.id}>
                      {conta.nome}
                    </option>
                  ))}
                </Form.Select>
                {contas.filter(conta => conta.status === 'ativa').length === 0 && (
                  <div className="text-warning mt-1" style={{ fontSize: '12px' }}>
                    Nenhuma conta ativa encontrada. Crie e autorize uma conta primeiro.
                  </div>
                )}
              </Form.Group>
              
              <Form.Group className="mb-3">
                <Form.Label>Em quais momentos as vendas devem ser enviadas para o Bling? <span className="text-danger">*</span></Form.Label>
                <Form.Select
                  value={regraForm.momento_envio}
                  onChange={(e) => setRegraForm({...regraForm, momento_envio: e.target.value})}
                >
                  <option value="">Selecione...</option>
                  <option value="Pagamento aprovado">Pagamento aprovado</option>
                  <option value="Pagamento agendado (Afterpay)">Pagamento agendado (Afterpay)</option>
                </Form.Select>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowRegraModal(false)}>
              Fechar
            </Button>
            <Button variant="primary" onClick={handleSaveRegra} disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar'}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal Confirmação Autorização */}
        <Modal show={showAuthModal} onHide={() => setShowAuthModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title className="d-flex align-items-center">
              <Icon icon="mdi:shield-check" className="me-2 text-warning" />
              Autorizar Conta Bling
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="text-center">
              <Icon icon="mdi:bling" className="text-5xl text-primary mb-3" />
              <span style={{ 
                fontSize: '16px', 
                fontWeight: '500',
                display: 'block',
                color: 'var(--dark-text-primary, #1a1a1a)',
                marginBottom: '8px'
              }}>
                Você será redirecionado para o Bling
              </span>
              <span style={{ 
                fontSize: '14px', 
                display: 'block',
                color: 'var(--dark-text-secondary, #6b7280)',
                marginBottom: '16px'
              }}>
                Para autorizar a conta: <strong>{contaParaAutorizar?.nome}</strong>
              </span>
              
              <div className="alert alert-success d-flex align-items-start text-start">
                <Icon icon="mdi:check-circle" className="me-2 mt-1" />
                <div>
                  <span style={{ fontSize: '14px' }}>
                    <strong>Autorização Simplificada:</strong><br/>
                    1. A autorização será feita automaticamente<br/>
                    2. Não é necessário sair da tela<br/>
                    3. Sua conta ficará ativa imediatamente<br/>
                    4. Você poderá criar regras de sincronização<br/>
                    5. Processo rápido e seguro
                  </span>
                </div>
              </div>
              
              <div className="mt-3">
                <span style={{ 
                  fontSize: '12px', 
                  color: 'var(--dark-text-secondary, #6b7280)'
                }}>
                  Client ID: <code>{contaParaAutorizar?.client_id}</code>
                </span>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowAuthModal(false)}>
              Cancelar
            </Button>
            <Button variant="success" onClick={confirmarAutorizacao} className="d-flex align-items-center">
              <Icon icon="mdi:check-circle" className="me-2" />
              Autorizar no Bling
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de Resultado da Autorização */}
        <Modal show={showResultModal} onHide={() => setShowResultModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              {resultType === 'success' ? (
                <span className="text-success">
                  <Icon icon="mdi:check-circle" className="me-2" />
                  Autorização Concluída
                </span>
              ) : (
                <span className="text-danger">
                  <Icon icon="mdi:alert-circle" className="me-2" />
                  Erro na Autorização
                </span>
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="text-center py-3">
              {resultType === 'success' ? (
                <Icon icon="mdi:check-circle" className="text-success" style={{ fontSize: '3rem' }} />
              ) : (
                <Icon icon="mdi:alert-circle" className="text-danger" style={{ fontSize: '3rem' }} />
              )}
              <p className="mt-3 mb-0">{resultMessage}</p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button 
              className="btn btn-primary"
              onClick={() => {
                setShowResultModal(false);
                loadContas(); // Recarregar lista de contas
              }}
            >
              <Icon icon="mdi:check" className="me-1" />
              OK
            </button>
          </Modal.Footer>
        </Modal>
      </MasterLayout>
    </>
  );
};

export default BlingIntegrationPage;